import { DateTime } from "@easepick/bundle";
import modelBaseV2 from "../model-base-v2.model";

const SiteSoldToShipToMappingModel = {
  getListSoldToShipTo: function (body) {
    let options = {};
    if (body) {
      options.body = body;
    }

    return modelBaseV2.post(`/api/site-soldto-shipto-mapping/search`, options);
  },
  createMapping: function (body) {
    return modelBaseV2.post("/api/site-soldto-shipto-mapping/add", {
      body: body,
    });
  },
  updateMapping: function (body) {
    return modelBaseV2.post("/api/site-soldto-shipto-mapping/update", {
      body: body,
    });
  },
  deleteMapping: function (body) {
    return modelBaseV2.post("/api/site-soldto-shipto-mapping/delete", {
      body: body,
    });
  },
  downloadExcel: function (body) {
    const filename = `Site_soldto_shipto_mapping_${DateTime.now()}`;
    return modelBaseV2.postDownload(
      "/api/site-soldto-shipto-mapping/excel-download",
      {
        body: body,
      },
      filename
    );
  },
  uploadExcel: (file) => {
    let body = new FormData();
    body.append("file", file);

    const indexOfExtension = file.name.lastIndexOf(".");
    let filename = file.name;
    filename =
      filename.substring(0, indexOfExtension) +
      "_RESULTS" +
      filename.substring(indexOfExtension);

    return modelBaseV2.post(
      "/api/site-soldto-shipto-mapping/excel-upload",
      { body },
      filename
    );
  },
};

export default SiteSoldToShipToMappingModel;
